import { PLAYLIST_CONTENT_API_PATH } from 'constants/api';
import { ContentInterface } from 'content/library/types/contentType';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { PlaylistItemInterface } from '../types/playlistType';
import { playlistApiService } from './playlistApiService';
import { playlistRuleService } from './playlistRuleService';

class PlaylistContentListService {
  constructor(private apiService: ApiService<ContentInterface>) {}

  public async fetch(query?: URLSearchParams): Promise<FetchResult<ContentInterface>> {
    return await this.apiService.fetch(query);
  }

  public async deleteIds(itemIds: number[]): Promise<void> {
    await Promise.all(itemIds.map(async id => this.apiService.delete(id)));
  }

  public async fetchByParentId(
    parentId: number,
    query: Record<string, string>
  ): Promise<PlaylistItemInterface[]> {
    const playlist = await playlistApiService.fetchById(parentId, query);
    return playlist.playlist_items;
  }

  public async createContentListInPlaylist(playlistId: number, ids: number[]): Promise<void> {
    const playlistContents = await playlistRuleService.fetchRules(playlistId);
    const playlistContentRule = playlistContents.find(content => content.value_type === 'content');
    const playlistContentIds = playlistContentRule?.value.split(',').map(Number) || [];
    const uniqueIds = Array.from(new Set([...playlistContentIds, ...ids]));
    const rule = {
      value_type: 'content',
      value: uniqueIds.join(','),
    };

    await playlistRuleService.upsertPlaylistRule(playlistId, [rule]);
  }

  public async deleteContentListInPlaylist(playlistId: number, ids: number[]): Promise<void> {
    const playlistContents = await playlistRuleService.fetchRules(playlistId);
    const playlistContentRule = playlistContents.find(content => content.value_type === 'content');
    const playlistContentIds = playlistContentRule?.value.split(',').map(Number) || [];
    const rule = {
      value_type: 'content',
      value: playlistContentIds.filter(id => !ids.includes(id)).join(','),
    };

    await playlistRuleService.upsertPlaylistRule(playlistId, [rule]);
  }
}

export const playlistContentListService = new PlaylistContentListService(
  new ApiService(PLAYLIST_CONTENT_API_PATH)
);
